"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  clipUnionOfContours: true,
  clipIntersectionOfContours: true,
  clipDifferenceOfContours: true,
  clipOffsetContours: true,
  standardizeContourTraversalDirection: true,
  PickContour: true,
  contourCutTime: true,
  convexDecomposition: true
};
Object.defineProperty(exports, "PickContour", {
  enumerable: true,
  get: function () {
    return _contourClipping.PickContour;
  }
});
Object.defineProperty(exports, "clipDifferenceOfContours", {
  enumerable: true,
  get: function () {
    return _contourClipping.clipDifferenceOfContours;
  }
});
Object.defineProperty(exports, "clipIntersectionOfContours", {
  enumerable: true,
  get: function () {
    return _contourClipping.clipIntersectionOfContours;
  }
});
Object.defineProperty(exports, "clipOffsetContours", {
  enumerable: true,
  get: function () {
    return _contourClipping.clipOffsetContours;
  }
});
Object.defineProperty(exports, "clipUnionOfContours", {
  enumerable: true,
  get: function () {
    return _contourClipping.clipUnionOfContours;
  }
});
Object.defineProperty(exports, "contourCutTime", {
  enumerable: true,
  get: function () {
    return _contourCutTime.contourCutTime;
  }
});
Object.defineProperty(exports, "convexDecomposition", {
  enumerable: true,
  get: function () {
    return _convexDecomposition.convexDecomposition;
  }
});
Object.defineProperty(exports, "standardizeContourTraversalDirection", {
  enumerable: true,
  get: function () {
    return _contourClipping.standardizeContourTraversalDirection;
  }
});
var _arcifyTypes = require("./arcifyTypes");
Object.keys(_arcifyTypes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _arcifyTypes[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _arcifyTypes[key];
    }
  });
});
var _nestingTypes = require("./nestingTypes");
Object.keys(_nestingTypes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _nestingTypes[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _nestingTypes[key];
    }
  });
});
var _unfoldTypes = require("./unfoldTypes");
Object.keys(_unfoldTypes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _unfoldTypes[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _unfoldTypes[key];
    }
  });
});
var _brentsmethod = require("./brentsmethod");
Object.keys(_brentsmethod).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _brentsmethod[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _brentsmethod[key];
    }
  });
});
var _bSpline = require("./bSpline");
Object.keys(_bSpline).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _bSpline[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _bSpline[key];
    }
  });
});
var _checkAngles = require("./checkAngles");
Object.keys(_checkAngles).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _checkAngles[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _checkAngles[key];
    }
  });
});
var _clipper = require("./clipper.js");
Object.keys(_clipper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _clipper[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _clipper[key];
    }
  });
});
var _computeBbox = require("./computeBbox");
Object.keys(_computeBbox).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _computeBbox[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _computeBbox[key];
    }
  });
});
var _connectedMesh = require("./connectedMesh");
Object.keys(_connectedMesh).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _connectedMesh[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _connectedMesh[key];
    }
  });
});
var _contourClipping = require("./contourClipping");
var _contourCutTime = require("./contourCutTime");
var _contourProperties = require("./contourProperties");
Object.keys(_contourProperties).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _contourProperties[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _contourProperties[key];
    }
  });
});
var _contourTopology = require("./contourTopology");
Object.keys(_contourTopology).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _contourTopology[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _contourTopology[key];
    }
  });
});
var _convertLineToArc = require("./convertLineToArc");
Object.keys(_convertLineToArc).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _convertLineToArc[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _convertLineToArc[key];
    }
  });
});
var _convexDecomposition = require("./convexDecomposition");
var _createLeadInGeometry = require("./createLeadInGeometry");
Object.keys(_createLeadInGeometry).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _createLeadInGeometry[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _createLeadInGeometry[key];
    }
  });
});
var _distanceToEntities = require("./distanceToEntities");
Object.keys(_distanceToEntities).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _distanceToEntities[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _distanceToEntities[key];
    }
  });
});
var _distanceToLineSegment = require("./distanceToLineSegment");
Object.keys(_distanceToLineSegment).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _distanceToLineSegment[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _distanceToLineSegment[key];
    }
  });
});
var _distanceToSpline = require("./distanceToSpline");
Object.keys(_distanceToSpline).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _distanceToSpline[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _distanceToSpline[key];
    }
  });
});
var _entityHitTest = require("./entityHitTest");
Object.keys(_entityHitTest).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _entityHitTest[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _entityHitTest[key];
    }
  });
});
var _fetchJson = require("./fetchJson");
Object.keys(_fetchJson).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _fetchJson[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _fetchJson[key];
    }
  });
});
var _findCrossings = require("./findCrossings");
Object.keys(_findCrossings).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _findCrossings[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _findCrossings[key];
    }
  });
});
var _findIntersections = require("./findIntersections");
Object.keys(_findIntersections).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _findIntersections[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _findIntersections[key];
    }
  });
});
var _findSelfIntersections = require("./findSelfIntersections");
Object.keys(_findSelfIntersections).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _findSelfIntersections[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _findSelfIntersections[key];
    }
  });
});
var _formatCents = require("./formatCents");
Object.keys(_formatCents).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _formatCents[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _formatCents[key];
    }
  });
});
var _generatePolyline = require("./generatePolyline");
Object.keys(_generatePolyline).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _generatePolyline[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _generatePolyline[key];
    }
  });
});
var _getPointTangent = require("./getPointTangent");
Object.keys(_getPointTangent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _getPointTangent[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getPointTangent[key];
    }
  });
});
var _getTangentNormalAtParametricPoint = require("./getTangentNormalAtParametricPoint");
Object.keys(_getTangentNormalAtParametricPoint).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _getTangentNormalAtParametricPoint[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getTangentNormalAtParametricPoint[key];
    }
  });
});
var _gjkInteresect = require("./gjkInteresect");
Object.keys(_gjkInteresect).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _gjkInteresect[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _gjkInteresect[key];
    }
  });
});
var _intersectEntities = require("./intersectEntities");
Object.keys(_intersectEntities).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _intersectEntities[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _intersectEntities[key];
    }
  });
});
var _naturalCompare = require("./naturalCompare");
Object.keys(_naturalCompare).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _naturalCompare[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _naturalCompare[key];
    }
  });
});
var _polyTopology = require("./polyTopology");
Object.keys(_polyTopology).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _polyTopology[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _polyTopology[key];
    }
  });
});
var _shortenEntities = require("./shortenEntities");
Object.keys(_shortenEntities).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _shortenEntities[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _shortenEntities[key];
    }
  });
});
var _subtractPolys = require("./subtractPolys");
Object.keys(_subtractPolys).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _subtractPolys[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _subtractPolys[key];
    }
  });
});
var _time = require("./time");
Object.keys(_time).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _time[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _time[key];
    }
  });
});
var _tubeTypes = require("./tubeTypes");
Object.keys(_tubeTypes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _tubeTypes[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _tubeTypes[key];
    }
  });
});
var _vector = require("./vector");
Object.keys(_vector).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _vector[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _vector[key];
    }
  });
});
var _warnonce = require("./warnonce");
Object.keys(_warnonce).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _warnonce[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _warnonce[key];
    }
  });
});
var _react = require("./react");
Object.keys(_react).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _react[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _react[key];
    }
  });
});
var _currency = require("./currency");
Object.keys(_currency).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _currency[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _currency[key];
    }
  });
});
var _scopes = require("./scopes");
Object.keys(_scopes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _scopes[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _scopes[key];
    }
  });
});